export default __webpack_public_path__ + "static/media/requests.78bfc7ad.jpg";